// Fallback when API pattern omits international AWB formats (suffixes like -IN, /USA, :IN).
export const DEFAULT_AWB_TRACKING_PATTERN =
  "^(?:\\d{11,17}|[A-Za-z0-9]{11,17}|[A-Za-z]{4,6}\\d{10,11}[A-Za-z]{2,3}(?:[-_/:][A-Za-z]{1,3})?)$";

const cleanRegexPattern = (pattern) =>
  pattern?.replace(/^\/|\/$/g, "").trim() || "";

const testPattern = (pattern, value) => {
  const cleaned = cleanRegexPattern(pattern);
  if (!cleaned) return false;
  try {
    return new RegExp(cleaned).test(value);
  } catch {
    return false;
  }
};

export const isValidTrackingAwb = (rawValue, storedPattern) => {
  const value = rawValue?.trim();
  if (!value) return false;

  const pattern =
    storedPattern ??
    (typeof localStorage !== "undefined" ? localStorage.getItem("regexPattern") : null);

  if (pattern && testPattern(pattern, value)) return true;
  return testPattern(DEFAULT_AWB_TRACKING_PATTERN, value);
};
